import { render, staticRenderFns } from "./companygoods.vue?vue&type=template&id=abf2cb52"
import script from "./companygoods.vue?vue&type=script&lang=js"
export * from "./companygoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports